<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="content min-vh-100 flex-column d-flex justify-content-between">
					<section>
						<h2 class="title">
							<img src="/img/ico-mins-medical.svg" />{{ title }}
						</h2>
						<p>
							<b>Travel Medical Expenses shall apply solely for claims that take place outside of the City of Domicile or the City of Residence of the Insured Party.</b>
							That exclusion shall not apply in the event that the Insured Party, in the City of Domicile or in the City of Residence at the time of the claim, is affected by the claim while carrying out an insured activity organized by the Insured Companies.
						</p>
						<p>{{ intro }}</p>
						<div class="accordion" role="tablist">
							<b-card v-for="(coverage, coverage_key) in coverages" :key="coverage_key" no-body class="mb-1">
								<div class="card-header">
									<h6>
										<button v-b-toggle="'coverage-'+coverage_key" class="btn btn-link collapsed" type="button">
											{{ coverage.title }}
										</button>
									</h6>
								</div>
								<b-collapse :id="'coverage-'+coverage_key" accordion="my-accordion" role="tabpanel">
									<b-card-body v-for="(chapter, chapter_key) in coverage.chapters" :key="chapter_key">
										<b-card-title>{{ chapter.title }}</b-card-title>
										<b-card-text v-html="chapter.text"></b-card-text>
										<b-card-sub-title>LIMIT</b-card-sub-title>
										<b-card-text v-html="chapter.limit || '-'"></b-card-text>
										<b-card-sub-title v-if="chapter.deductible">DEDUCTIBLE</b-card-sub-title>
										<b-card-text v-if="chapter.deductible" v-html="chapter.deductible"></b-card-text>
									</b-card-body>
								</b-collapse>
							</b-card>
						</div>
					</section>
					<ReadAllTermsAndConditions/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ReadAllTermsAndConditions from '@/components/ReadAllTermsAndConditions.vue'

export default {
	components: {
		ReadAllTermsAndConditions,
	},
	data(){
		return {
			title: "MEDICAL EXPENSES",
			intro: "Should the Insured Party have to sustain urgent medical, pharmaceutical, hospital, treatment or surgical expenses that cannot be delayed during the period of validity of the Guarantee, the Company shall cover the costs as specified below:",
			coverages: [
				{
					title: "MEDICAL EXPENSES OUTSIDE THE INSURED PARTY'S CITY OF RESIDENCE",
					chapters: [
						{
							title: "AUTHORIZED BY THE OPERATIONS CENTER",
							text: "<b>DIRECT PAYMENT</b><br/>The Guarantee shall be provided until the date of discharge following Hospitalization, for a maximum of 365 consecutive days, until the end of the treatment in the case of emergency room care or until the time that the Insured Party, in the judgment of the Company’s doctors, is deemed to be in a condition to be repatriated.<br/><br/><b>THROUGH REIMBURSEMENT</b><br/> against submission of suitable clinical and financial documentation if the Insured contacts the Operations Centre in advance",
							limit: "€1.000.000 per claim and annual aggregate",
							deductible: "none"
						},
						{
							title: "WITHOUT AUTHORIZATION BY THE OPERATIONS CENTER",
							text: "<b>THROUGH REIMBURSEMENT</b><br/>against submission of suitable clinical and financial documentation. In the case of hospitalization, no medical expenses shall be reimbursed in the absence of prior contact contact of the Operations Center (except when proven to be impossible).",
							limit: "€ 5.000 per claim and annual aggregate"
						}
					]
				},
				{
					title: "MEDICAL EXPENSES INSIDE THE INSURED PARTY'S CITY OF RESIDENCE",
					chapters: [
						{
							title: "AUTHORIZED BY THE OPERATIONS CENTER",
							text: "<b>DIRECT PAYMENT</b><br/>The Guarantee shall be provided until the date of discharge following Hospitalization, for a maximum of 365 consecutive days, until the end of the treatment in the case of emergency room care or until the time that the Insured Party, in the judgment of the Company’s doctors, is deemed to be in a condition to be repatriated.<br/><br/><b>THROUGH REIMBURSEMENT</b><br/>  against submission of suitable clinical and financial documentation if the Insured contacts the Operations Centre in advance",
							limit: "€200.000 per claim and annual aggregate",
							deductible: "€ 2.000"
						},
						{
							title: "WITHOUT AUTHORIZATION BY THE OPERATIONS CENTER",
							text: "<b>THROUGH REIMBURSEMENT</b><br/>against submission of suitable clinical and financial documentation. In the case of hospitalization, no medical expenses shall be reimbursed in the absence of prior contact contact of the Operations Center (except when proven to be impossible).",
							limit: "€ 5.000 per claim and annual aggregate"
						}
					]
				},
				{
					title: " MEDICAL EXPENSES FOR DENTAL CARE",
					chapters: [
						{
							title: "",
							text: "The Company shall reimburse expenses for urgent dental care during the Trip abroad.",
							limit: "€ 1.500 per claim and annual aggregate"
						}
					]
				},
				{
					title: "MEDICAL EXPENSES UPON RETURN TO RESIDENCE OR DOMICILE",
					chapters: [
						{
							title: "",
							text: "In the case of Hospitalization of the Insured Party abroad, the Company shall reimburse the medical expenses sustained upon return to the Residence or Domicile, in addition to (or in the absence of) what is stated by the main medical policy or any other valid insurance coverage.",
							limit: "€30.000 limited to €15.000 for prosthetics per claim and annual aggregate"
						}
					]
				},
				{
					title: "AESTHETIC DEFORMITY",
					chapters: [
						{
							title: "",
							text: "The Company shall reimburse the medical expenses following an Injury or Illness occurring during Travel that has caused an aesthetic deformity.",
							limit: "€ 3.000 per claim and annual aggregate"
						}
					]
				},
				{
					title: "MEDICAL EXPENSES FOR PSYCHOLOGICAL VISITS",
					chapters: [
						{
							title: "",
							text: "The Company shall reimburse the expenses for psychological visits following Illness or Injury during Travel that has caused Hospitalization exceeding 30 days, or in the event that the Insured Party needs psychological support due to events that took place during the Trip.",
							limit: "€ 3.000 per claim and annual aggregate"
						}
					]
				},
			]
		}
	}
}
</script>
